// src/store/rootReducer.js
import { combineReducers } from "redux";
import authReducer from "./auth";
import { clearUser } from "./auth/userSlice";
import sidebarReducer from "./modules";

const appReducer = combineReducers({
	auth: authReducer,
	modules: sidebarReducer,
});

const rootReducer = (state, action) => {
	if (action.type === clearUser.type) {
		state = undefined; // Reset entire Redux state
	}
	return appReducer(state, action);
};

export default rootReducer;
